module.exports = __webpack_public_path__ + "static/img/11.aaaa658.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/zh/11.png
// module id = 2i9k
// module chunks = 0